import * as React from "react";
import { Widget, mk_widget, any } from "widgets-for-react";
import { styleguideChapter, styleguideSection, styleguideTokenPart, styleguideTokenRow} from "../helpers";

export const  styleguideTokens: Widget<never> = mk_widget ({
  run: _ => (
    styleguideChapter({ type: 'tokens', slug: 'tokens', title: 'Design tokens', intro: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.'}) (
      any()([
        styleguideSection({ type: 'tokens', slug: 'tokens-colors', title: 'Colors'})(
          styleguideTokenPart({ hasExampleColumn: true, hasAttributeColumn: true, hasDescriptionColumn: true })(
            any()([
              styleguideTokenRow({ code: '$color--blue', attributes: '#015FF0', columnCount: 4, hasSeperator: false, hasExample: true, description:'Primary color', hasLabel: true, label:'Blues'})(
                mk_widget({
                  run: _ => (
                    <div className="styleguide-token__color token-color--015FF0"></div>
                  )
                })
              ),
              styleguideTokenRow({ code: '$color--blue-dark', attributes: '#0C1F3D', columnCount: 4, hasSeperator: false, hasExample: true, description:'Primary color - darker', hasLabel: false})(
                mk_widget({
                  run: _ => (
                    <div className="styleguide-token__color token-color--0C1F3D"></div>
                  )
                })
              ),
              styleguideTokenRow({ code: '$color--black', attributes: '#112233', columnCount: 4, hasSeperator: false, hasExample: true, description:'Black', hasLabel: true, label:'Black'})(
                mk_widget({
                  run: _ => (
                    <div className="styleguide-token__color token-color--112233"></div>
                  )
                })
              ),
              styleguideTokenRow({ code: '$color--grey', attributes: '#EDEDED', columnCount: 4, hasSeperator: false, hasExample: true, description:'Grey', hasLabel: true, label: 'Greys'})(
                mk_widget({
                  run: _ => (
                    <div className="styleguide-token__color token-color--EDEDED"></div>
                  )
                })
              ),
              styleguideTokenRow({ code: '$color--grey-dark', attributes: '#334455', columnCount: 4, hasSeperator: false, hasExample: true, description:'Text color', hasLabel: false})(
                mk_widget({
                  run: _ => (
                    <div className="styleguide-token__color token-color--334455"></div>
                  )
                })
              ),
              styleguideTokenRow({ code: '$color--white', attributes: '#FFFFFF', columnCount: 4, hasSeperator: false, hasExample: true, description:'White', hasLabel: true, label: 'White'})(
                mk_widget({
                  run: _ => (
                    <div className="styleguide-token__color token-color--FFFFFF"></div>
                  )
                })
              ),
            ]),
          )
        ),
        styleguideSection({ type: 'tokens', slug: 'tokens-fonts', title: 'Fonts'})(
          styleguideTokenPart({ hasExampleColumn: true, hasAttributeColumn: true, hasDescriptionColumn: false })(
            any()([
              styleguideTokenRow({ code: '$font--gilroy', attributes: 'Gilroy, sans-serif', columnCount: 3, hasSeperator: true, hasExample: true,  hasLabel: false})(
                mk_widget({
                  run: _ => (
                    <p className="token-font--gilroy">Vulputate Commodo Sollicitudin Fringilla Nullam. Etiam porta sem malesuada magna mollis euismod.</p>
                  )
                })
              ),
              styleguideTokenRow({ code: '$font--maax', attributes: 'Maax, sans-serif', columnCount: 3, hasSeperator: false, hasExample: true, hasLabel: false})(
                mk_widget({
                  run: _ => (
                    <p className="token-font--maax">Vulputate Commodo Sollicitudin Fringilla Nullam. Etiam porta sem malesuada magna mollis euismod.</p>
                  )
                })
              ),
            ]),
          )
        ),
        styleguideSection({ type: 'tokens', slug: 'tokens-styles', title: 'Font Styles'})(
          styleguideTokenPart({ hasExampleColumn: true, hasAttributeColumn: true, hasDescriptionColumn: false })(
            any()([
              styleguideTokenRow({ code: '$weight--400', attributes: 'Font-weight: Regular, Font-family: Maax', columnCount: 3, hasSeperator: false, hasExample: true, hasLabel: false})(
                mk_widget({
                  run: _ => (
                    <>
                      <p className="token-weight--400 token-font--maax">Vulputate Commodo Sollicitudin Fringilla Nullam. Etiam porta sem malesuada magna mollis euismod.</p>
                    </>
                  )
                })
              ),
              styleguideTokenRow({ code: '$weight--600', attributes: 'Font-weight: Bold, Font-family: Maax', columnCount: 3, hasSeperator: false, hasExample: true, hasLabel: false})(
                mk_widget({
                  run: _ => (
                    <>
                      <p className="token-weight--600 token-font--maax">Vulputate Commodo Sollicitudin Fringilla Nullam. Etiam porta sem malesuada magna mollis euismod.</p>
                    </>
                  )
                })
              ),
              styleguideTokenRow({ code: '$weight--800', attributes: 'Font-weight: Black, Font-family: Gilroy', columnCount: 3, hasSeperator: false, hasExample: true, hasLabel: false})(
                mk_widget({
                  run: _ => (
                    <>
                      <p className="token-weight--800 token-font--gilroy">Vulputate Commodo Sollicitudin Fringilla Nullam. Etiam porta sem malesuada magna mollis euismod.</p>
                    </>
                  )
                })
              )
            ]),
          )
        ),
        styleguideSection({ type: 'tokens', slug: 'tokens-sizes-heights', title: 'Font Sizes & Line heights'})(
          styleguideTokenPart({ hasExampleColumn: true, hasAttributeColumn: true, hasDescriptionColumn: false, exampleIsLarger: true })(
            any()([
              styleguideTokenRow({ code: '%typo--3xl', attributes: 'Font-size: 40px > 120px, Line-height: 128/120', columnCount: 3, hasSeperator: false, hasExample: true, hasLabel: false})(
                mk_widget({
                  run: _ => (
                    <p className="typo--3xl">Euismod Mollis Tortor</p>
                  )
                })
              ),
              styleguideTokenRow({ code: '%typo--2xl', attributes: 'Font-size: 36px > 72px, Line-height: 80/72', columnCount: 3, hasSeperator: false, hasExample: true, hasLabel: false})(
                mk_widget({
                  run: _ => (
                    <p className="typo--2xl">Egestas Mattis Vulputate.</p>
                  )
                })
              ),
              styleguideTokenRow({ code: '%typo--xl', attributes: 'Font-size: 32px > 56px, Line-height: 64/56', columnCount: 3, hasSeperator: false, hasExample: true, hasLabel: false})(
                mk_widget({
                  run: _ => (
                    <p className="typo--xl">Cursus Fermentum Ornare Sem</p>
                  )
                })
              ),
              styleguideTokenRow({ code: '%typo--l', attributes: 'Font-size: 24px > 36px, Line-height: 48/36', columnCount: 3, hasSeperator: false, hasExample: true, hasLabel: false})(
                mk_widget({
                  run: _ => (
                    <p className="typo--l">Nullam quis risus eget urna mollis ornare vel eu leo.</p>
                  )
                })
              ),
              styleguideTokenRow({ code: '%typo--m', attributes: 'Font-size: 20px > 32px, Line-height:40/32', columnCount: 3, hasSeperator: false, hasExample: true, hasLabel: false})(
                mk_widget({
                  run: _ => (
                    <p className="typo--m">Maecenas sed diam eget risus varius blandit sit amet non magna.</p>
                  )
                })
              ),
              styleguideTokenRow({ code: '%typo--s', attributes: 'Font-size: 20px > 24px, Line-height: 32/24', columnCount: 3, hasSeperator: false, hasExample: true, hasLabel: false})(
                mk_widget({
                  run: _ => (
                    <p className="typo--s">Dubbeldam verkoopt wereldwijd ingrediënten en halffabricaten voor producenten van kindervoeding.</p>
                  )
                })
              ),
              styleguideTokenRow({ code: '%typo--xs', attributes: 'Font-size: 16px > 20px, Line-height: 32/20, Lettersapciing: 0.2', columnCount: 3, hasSeperator: false, hasExample: true, hasLabel: false})(
                mk_widget({
                  run: _ => (
                    <p className="typo--xs">Dubbeldam produceert en verkoopt consumentenproducten als zuiveldranken, kindervoeding, kaas en desserts in een groot aantal Europese landen, in Azië en in Afrika via eigen dochterondernemingen. </p>
                  )
                })
              ),
              styleguideTokenRow({ code: '%typo--2xs', attributes: 'Font-size: 14px > 18px, Line-height: 32/18, Lettersapciing: 0.2', columnCount: 3, hasSeperator: false, hasExample: true, hasLabel: false})(
                mk_widget({
                  run: _ => (
                    <p className="typo--2xs"> Daarnaast worden vanuit Nederland wereldwijd zuivelproducten geëxporteerd.</p>
                  )
                })
              ),
              styleguideTokenRow({ code: '%typo--3xs', attributes: 'Font-size: 12px > 16px, Line-height: 24/14,  Lettersapciing: 0.2', columnCount: 3, hasSeperator: false, hasExample: true, hasLabel: false})(
                mk_widget({
                  run: _ => (
                    <p className="typo--3xs">Bij de koeien die het produceren en onze boeren: het hart van onze cooperatie. </p>
                  )
                })
              )
            ]),
          )
        ),
        styleguideSection({ type: 'tokens', slug: 'tokens-widths', title: 'Widths'})(
          styleguideTokenPart({ hasExampleColumn: false, hasAttributeColumn: true, hasDescriptionColumn: false, exampleIsLarger: true })(
            any()([
              styleguideTokenRow({ code: '$width--m', attributes: 'width: 960px, width with gutters: 1152px', columnCount: 2, hasSeperator: false, hasExample: false, hasLabel: false})(
                mk_widget({
                  run: _ => (
                    <> </>
                  )
                })
              ),
              styleguideTokenRow({ code: '$width--s', attributes: 'width: 1728px, width with gutters: 1920px', columnCount: 2, hasSeperator: false, hasExample: false, hasLabel: false})(
                mk_widget({
                  run: _ => (
                    <> </>
                  )
                })
              )
            ]),
          )
        ),
        styleguideSection({ type: 'tokens', slug: 'tokens-spacing-gutter', title: 'Spacing & gutters', intro: "The 'spacing'-variables are used for vertical spacing, while the 'gutter'-variables are used for horizontal spacing."})(
          styleguideTokenPart({ hasExampleColumn: false, hasAttributeColumn: true, hasDescriptionColumn: false, exampleIsLarger: true, })(
            any()([
              styleguideTokenRow({ code: '%gutter--default', attributes: 'mobile: 5%, tablet/desktop: 10%', columnCount: 2, hasSeperator: false, hasExample: false, hasLabel: false})(
                mk_widget({
                  run: _ => (
                    <> </>
                  )
                })
              ),
              styleguideTokenRow({ code: '%spacing--default', attributes: 'mobile: 40px, tablet: 80px, desktop: 120px', columnCount: 2, hasSeperator: false, hasExample: false, hasLabel: false})(
                mk_widget({
                  run: _ => (
                    <> </>
                  )
                })
              )
            ]),
          )
        ),
        styleguideSection({ type: 'tokens', slug: 'tokens-icons', title: 'Icons'})(
          styleguideTokenPart({ hasExampleColumn: true, hasAttributeColumn: false, hasDescriptionColumn: false, exampleIsLarger: true, })(
            any()([
              styleguideTokenRow({ code: '#arrow--right', columnCount: 2, hasSeperator: false, hasExample: true, hasLabel: false})(
                mk_widget({
                  run: _ => (
                    <svg height="16" width="16" aria-hidden="true">
                      <use xlinkHref="#arrow--right" />
                    </svg>
                  )
                })
              ),
            ]),
          )
        )
      ])
    ).run(_)
  )
})